function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_21_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_4_",
  d: "M0.005,149.995c0,59.367,34.502,110.683,84.543,134.992L12.994,88.953 C4.674,107.607,0.005,128.25,0.005,149.995z M251.259,142.429c0-18.544-6.661-31.377-12.367-41.366 c-7.602-12.362-14.729-22.817-14.729-35.18c0-13.788,10.449-26.621,25.184-26.621c0.668,0,1.301,0.081,1.943,0.122 C224.608,14.932,189.049,0,150,0C97.597,0,51.497,26.89,24.674,67.603c3.525,0.116,6.843,0.188,9.655,0.188 c15.685,0,39.98-1.907,39.98-1.907c8.083-0.476,9.033,11.406,0.956,12.362c0,0-8.129,0.951-17.163,1.422l54.619,162.478 l32.827-98.447L122.18,79.667c-8.083-0.471-15.73-1.422-15.73-1.422c-8.083-0.48-7.138-12.838,0.95-12.362 c0,0,24.766,1.907,39.505,1.907c15.686,0,39.98-1.907,39.98-1.907c8.083-0.476,9.039,11.406,0.956,12.362 c0,0-8.138,0.951-17.162,1.422l54.203,161.238l14.962-49.984C247.45,171.427,251.259,155.266,251.259,142.429z M152.636,163.116 L107.628,293.89C121.067,297.841,135.28,300,150,300c17.471,0,34.224-3.015,49.813-8.503c-0.395-0.643-0.769-1.324-1.072-2.068 L152.636,163.116z M281.624,78.038c0.647,4.774,1.012,9.898,1.012,15.422c0,15.215-2.854,32.326-11.412,53.723l-45.812,132.459 c44.598-26,74.583-74.311,74.583-129.646C299.995,123.915,293.328,99.398,281.624,78.038z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgWordpress = function SvgWordpress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWordpress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wordpress.3db35dc5.svg";
export { ForwardRef as ReactComponent };